/*
 * No.9 Caffè — Product Showcase
 * 1) Waitlist <dialog> email-capture modal for "coming soon" cards.
 * 2) Mobile slider scroll-progress indicator (.ps-no9__progress thumb).
 * 3) Format toggle (beans / capsules): sets the page-wide, remembered
 *    <html data-no9-format> that cards and other sections follow.
 * Uses event delegation + per-element guards so it survives Shopify section
 * re-renders in the theme editor.
 */
(function () {
  if (window.__no9Showcase) return;
  window.__no9Showcase = true;

  /* ---- Waitlist signup ----
     Submitted with fetch rather than a normal POST. A normal submit reloads the
     page, which both closes the dialog and sets ?customer_posted=true — and that
     flag makes form.posted_successfully? read true for EVERY customer form on
     the page, so the footer newsletter and this dialog would report each other's
     successes. Posting in the background keeps the two independent. */
  document.addEventListener('submit', function (e) {
    const form = e.target.closest && e.target.closest('.no9-waitlist__form');
    if (!form) return;

    e.preventDefault();
    const field = form.querySelector('[data-waitlist-field]');
    const success = form.querySelector('[data-waitlist-success]');
    const submit = form.querySelector('.no9-waitlist__submit');
    if (submit) submit.disabled = true;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' },
    })
      .then(function () {
        // The address is captured even when Shopify answers with a duplicate-
        // customer notice, so anything short of a network failure is a success
        // from the shopper's point of view.
        if (field) field.hidden = true;
        if (success) success.hidden = false;
      })
      .catch(function () {
        if (submit) submit.disabled = false;
        form.submit(); // fall back to a normal post
      });
  });

  /* ---- Waitlist modal ---- */
  document.addEventListener('click', function (e) {
    const opener = e.target.closest('[data-waitlist-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-waitlist-open'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    if (e.target.closest('[data-waitlist-close]')) {
      const dialog = e.target.closest('dialog');
      if (dialog) dialog.close();
      return;
    }
    if (e.target.classList && e.target.classList.contains('no9-waitlist')) {
      e.target.close();
    }
  });

  /* ---- Whole-card click → product page ----
     Delegated so it survives section re-renders. Guards: a real link/button
     inside the card handles its own click; a drag/swipe (mobile slider) or a
     text selection never navigates. */
  var downX = 0;
  var downY = 0;
  var dragged = false;

  document.addEventListener(
    'pointerdown',
    function (e) {
      downX = e.clientX;
      downY = e.clientY;
      dragged = false;
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    function (e) {
      if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) dragged = true;
    },
    { passive: true }
  );

  document.addEventListener('click', function (e) {
    const card = e.target.closest('.ps-no9__card[data-card-href]');
    if (!card) return;
    if (dragged) return; // swipe / drag, not a tap
    if (e.target.closest('a, button, input, select, textarea, label, [role="button"]')) return;
    if (window.getSelection && String(window.getSelection())) return; // selecting text
    const href = card.getAttribute('data-card-href');
    if (href) window.location.href = href;
  });

  /* ---- Mobile slider progress ---- */
  function initSlider(grid) {
    if (grid.__no9Slider) return;
    grid.__no9Slider = true;
    const progress = grid.parentElement.querySelector('.ps-no9__progress');
    if (!progress) return;
    const thumb = progress.querySelector('.ps-no9__progress-thumb');
    if (!thumb) return;

    function update() {
      const max = grid.scrollWidth - grid.clientWidth;
      if (max <= 2) {
        progress.style.visibility = 'hidden';
        return;
      }
      progress.style.visibility = 'visible';
      const ratio = grid.clientWidth / grid.scrollWidth; // 0..1 (thumb size)
      const pos = grid.scrollLeft / max; // 0..1 (position)
      thumb.style.width = ratio * 100 + '%';
      thumb.style.left = pos * (100 - ratio * 100) + '%';
    }

    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.ps-no9__grid').forEach(initSlider);
  }

  /* ---- Format toggle (beans / capsules) ----
     The format is page-wide: <html data-no9-format="2"> = capsules, no
     attribute = beans (snippets/no9-format.liquid applies the saved choice
     before paint). Every toggle on the page, its cards and any section with
     .no9-format-only-* follow that one attribute. */
  function currentFormat() {
    return document.documentElement.getAttribute('data-no9-format') === '2' ? '2' : '1';
  }

  function syncTabs(focusList) {
    const tab = currentFormat();
    document.querySelectorAll('.ps-no9__tabs').forEach(function (list) {
      list.querySelectorAll('.ps-no9__tab').forEach(function (btn) {
        const on = btn.getAttribute('data-ps-tab') === tab;
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.tabIndex = on ? 0 : -1;
        if (on && focusList === list) btn.focus();
        if (on) {
          const grid = document.getElementById(btn.getAttribute('aria-controls'));
          if (grid) grid.setAttribute('aria-labelledby', btn.id);
        }
      });
    });
  }

  // remember: false in the theme editor's block-select, so browsing blocks
  // there doesn't overwrite the merchant's own saved choice.
  function selectTab(tab, opts) {
    opts = opts || {};
    if (tab === currentFormat()) return;
    if (tab === '2') document.documentElement.setAttribute('data-no9-format', '2');
    else document.documentElement.removeAttribute('data-no9-format');
    if (opts.remember !== false) {
      try { localStorage.setItem('no9-format', tab); } catch (e) {}
    }
    syncTabs(opts.focusList);
    // Mobile sliders now hold a different set of cards: back to the start,
    // and let the progress bars re-measure.
    document.querySelectorAll('.ps-no9--tabs .ps-no9__grid').forEach(function (grid) {
      grid.scrollLeft = 0;
      grid.dispatchEvent(new Event('scroll'));
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.ps-no9__tab[data-ps-tab]');
    if (!btn) return;
    selectTab(btn.getAttribute('data-ps-tab'));
  });

  // Arrow keys move between the two options (WAI-ARIA tabs pattern).
  document.addEventListener('keydown', function (e) {
    const btn = e.target.closest && e.target.closest('.ps-no9__tab[data-ps-tab]');
    if (!btn || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
    e.preventDefault();
    const tabs = Array.prototype.slice.call(btn.parentElement.querySelectorAll('.ps-no9__tab'));
    const i = tabs.indexOf(btn);
    const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
    selectTab(next.getAttribute('data-ps-tab'), { focusList: btn.parentElement });
  });

  // Theme editor: selecting a card that sits under the other button flips to it.
  document.addEventListener('shopify:block:select', function (e) {
    const card = e.target.closest && e.target.closest('.ps-no9__card[data-ps-card-tab]');
    if (!card) return;
    const tab = card.getAttribute('data-ps-card-tab');
    if (tab === '1' || tab === '2') selectTab(tab, { remember: false });
  });

  function boot() {
    initAll();
    syncTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    syncTabs();
  });
})();
